import {API} from '@/app-core/api/Api'

export default {

  async Get(data = {}) {
    const Endpoint = API.Endpoint.Otp.Get
    const Data = data
    return await API.RESTRequest(Endpoint, Data)
  },

  async Validate(data = {}) {
    const Endpoint = API.Endpoint.Otp.Validate
    const Data = data
    return await API.RESTRequest(Endpoint, Data)
  }

}
